import React, { Component } from 'react'
import { Form } from "@ant-design/compatible";
import {
    Row,
    Col,
    DatePicker,
    Spin,
    Tooltip,
    Space,
    Tag,
    Select,
    Modal as modal,
    Space as space,
    Button as button,
    Pagination,
    Tabs,
    Table,
    Modal,
    Input, Button, Divider,
  } from "antd";
  import moment from "moment";
  import PrimaryButton from "../CommonComponent/Buttons/PrimayButton";
  import axios from "axios";
  import Config from "../../config";
  import Report_Home from ".././images/Report_Home.svg";
  import { SearchOutlined } from "@ant-design/icons";
  import blackscreen from ".././images/No_Reports.svg";
  import UltimateLogo from ".././images/ReportLogos/UltimateLogo.png";
  import mirranew from ".././images/new_mirra_logo.png";
  import ExportJsonExcel from "js-export-excel";
  import jsPDF from "jspdf";
import { async } from 'rxjs';
  const { Option } = Select;
  const { Search } = Input;

 class Rosterreport extends Component {
  searchController = null;
  npiController = null;
    constructor(props) {
        super(props);
       console.log("Rosterreport",props)
       this.state = {
        Fromwhere: "Report",
        TicketShow: false,
        reportLoading: false,
        selProviders: [],
        selpayeename: [],
        providerLoader: false,
        payeeLoader: false,
        selIpaNames: [],
        ipaNameList: [],
        providernameList: [],
        payeenameList: [],
        showFound: false,
        GroupOrIpaField: true,
        pcpReport: 1,
        isLoading: false,
        startDate: "",
        endDate: "",
        rowsPerPage: 15,
        currentPage: 1,
        totalrecored: 0,
        enableGenrateButton: false,
        selectedIapname: [],
        searchText: "",
        searchedColumn: "",
        filteredData: [],
        filters: {},
        providerTaxIdList:[],
        providerNpiList:[],
        ApiData: [],
        TotalCount:0,
        selTaxid:[],
        selnpi:[],
        DwonloadRosterReport:[],
        DwonloadRosterlodar:false,
        selectedTaxIds1:[],
        selectedNPIs:[],
        locationModalVisible: false,
        selectedPracticeLocations: [],
        website:""
        
        
      };
        
      }


      componentDidUpdate(prevProps) {
        if (prevProps.activeTab !== this.props.activeTab &&
            this.props.activeTab === "2") {
          this.onTabActive();
        }
      }
      
      onTabActive = () => {
        console.log("Roster Report tab is active");
         this.handleReset()
      };


  
  onProviderNPIChange = (value) => {
    if (typeof value === "string") {
      value = [value];
    }
  
    const sSelectAll = "Select All";
    let updatedList = [];
  
    if (
      (value[0] === sSelectAll && value.length === 1) ||
      (value[value.length - 1] === sSelectAll && value.length > 1)
    ) {
      updatedList = [sSelectAll];
    } else if (value[0] === sSelectAll && value.length > 1) {
      updatedList = value.filter(x => x !== sSelectAll);
    } else if (
      !value.includes(sSelectAll) &&
      this.state.selectedNPIs.includes(sSelectAll)
    ) {
      updatedList = value.filter(x => x !== sSelectAll);
    } else if (
      !value.includes(sSelectAll) &&
      value.length === this.state.providerNpiList.length - 1
    ) {
      updatedList = value;
    } else if (
      this.state.selectedNPIs.includes(sSelectAll) &&
      value.includes(sSelectAll) &&
      value.length < this.state.providerNpiList.length
    ) {
      updatedList = value.filter(x => x !== sSelectAll);
    } else if (value.includes(sSelectAll)) {
      updatedList = value;
    } else {
      updatedList = value;
    }
  
    let selNPI = [];
  
    if (updatedList.includes(sSelectAll)) {
      selNPI = this.state.providerNpiList
        .filter(item => item.npinumber !== sSelectAll)
        .map(item => item.npinumber);
    } else {
      selNPI = updatedList.filter(item => item !== sSelectAll);
    }

    console.log(updatedList)
  
    this.setState({
      selectedNPIs: updatedList,
      selnpi: selNPI,
    });
  
    return updatedList;
  };


  onProviderTaxIdChange = (value) => {
    if (typeof value === "string") {
      value = [value];
    }
  
    const sSelectAll = "Select All";
  
    let updatedList = [];
  
    if (
      (value[0] === sSelectAll && value.length === 1) ||
      (value[value.length - 1] === sSelectAll && value.length > 1)
    ) {
      updatedList = [sSelectAll];
    }
    else if (value[0] === sSelectAll && value.length > 1) {
      updatedList = value.filter(x => x !== sSelectAll);
    }
    else if (
      !value.includes(sSelectAll) &&
      this.state.selectedTaxIds1.includes(sSelectAll)
    ) {
      updatedList = value.filter(x => x !== sSelectAll);
    }
    else if (
      !value.includes(sSelectAll) &&
      value.length === this.state.providerTaxIdList.length - 1
    ) {
      updatedList = value;
    }
    else if (
      this.state.selectedTaxIds1.includes(sSelectAll) &&
      value.includes(sSelectAll) &&
      value.length < this.state.providerTaxIdList.length
    ) {
      updatedList = value.filter(x => x !== sSelectAll);
    }
    else if (value.includes(sSelectAll)) {
      updatedList = value;
    }
    else {
      updatedList = value;
    }
  
    console.log(updatedList)
    console.log(this.state.providerTaxIdList)
    let selTaxid = [];

if (updatedList.includes("Select All")) {
  selTaxid = this.state.providerTaxIdList
    .filter(item => item.providerTaxId !== "Select All")
    .map(item => item.providerTaxId);
} else {
  selTaxid = updatedList.filter(item => item !== "Select All");
}
    this.setState({
      selectedTaxIds1: updatedList,
      selTaxid:selTaxid
    });
  
    return updatedList;
  };
 


      onProviderChange = (value) => {
        console.log("value", value);
      
        this.props.form.setFieldsValue({
          providerTaxId: [],
          providerNPI: [],
        });
      
        if (typeof value === "string") {
          value = [value];
        }
      
        const sSelectAll = JSON.stringify({
          npinumber: "Select All",
          FullName: "Select All",
          providerTaxId: "Select All",
        });
      

        console.log("sSelectAll",sSelectAll)
        let updatedList = [];
      
        if (
          (value[0] === sSelectAll && value.length === 1) ||
          (value[value.length - 1] === sSelectAll && value.length > 1)
        ) {
          updatedList = [sSelectAll];
        }
        else if (value[0] === sSelectAll && value.length > 1) {
          updatedList = value.filter(x => x !== sSelectAll);
        }
        else if (
          !value.includes(sSelectAll) &&
          this.state.selProviders.includes(sSelectAll)
        ) {
          updatedList = value.filter(x => x !== sSelectAll);
        }
        else if (
          !value.includes(sSelectAll) &&
          value.length === this.state.providernameList.length - 1
        ) {
          updatedList = value;
        }
        else if (
          this.state.selProviders.includes(sSelectAll) &&
          value.includes(sSelectAll) &&
          value.length < this.state.providernameList.length
        ) {
          updatedList = value.filter(x => x !== sSelectAll);
        }
        else if (value.includes(sSelectAll)) {
          updatedList = value;
        }
        else {
          updatedList = value;
        }


        const hasSelectAll = updatedList.some(item => {
          const data = typeof item === "string" ? JSON.parse(item) : item;
          return data.npinumber === "Select All";
        });
        
        const sourceList = hasSelectAll
          ? this.state.providernameList // Objects
          : updatedList;                // JSON strings
        
        const providerData = sourceList.map(item =>
          typeof item === "string" ? JSON.parse(item) : item
        );
        
        console.log(providerData);      
        // Tax IDs
        let taxIdList = [
          ...new Map(
            providerData
              .filter(item => item.providerTaxId && item.providerTaxId !== "Select All")
              .map(item => [item.providerTaxId, item])
          ).values(),
        ].map(item => ({
          providerTaxId: item.providerTaxId,
        }));
      
        if (taxIdList.length > 1) {
          taxIdList.unshift({ providerTaxId: "Select All" });
        }
      
         console.log(taxIdList)

        // NPIs
        let npiList = [
          ...new Map(
            providerData
              .filter(
                item => item.npinumber && item.npinumber !== "Select All"
              )
              .map(item => [item.npinumber, item.npinumber])
          ).values(),
        ].map(npi => ({
          npinumber: npi,
        }));
      
        if (npiList.length > 1) {
          npiList.unshift({
            npinumber: "Select All",
          });
        }
      
        this.setState({
          selProviders: updatedList,
          providerLoader: false,
          providerTaxIdList: taxIdList,
          providerNpiList: npiList,
        });
      
        return updatedList;
      };
    


      componentDidMount() {
        if (
          sessionStorage.getItem("rolename").includes("Provider") ||
          (sessionStorage.getItem("planName") !== "ultimate" &&
            sessionStorage.getItem("rolename").includes("Group User"))
        ) {
          this.setState({ GroupOrIpaField: false });
        }
        console.log("Component Mounted");
        this.getipaNameList(true);  
      }


      // getpaginationData = (allRows, currentPage) => {
      //   console.log(this.state.totalrecored)
      //   console.log(allRows)
      //   console.log(currentPage)
      //   const indexOfLastRow = currentPage * this.state.rowsPerPage;
      //   // console.log(indexOfLastRow)
      //   const indexOfFirstRow = indexOfLastRow - this.state.rowsPerPage;
      //   const currentPageData = allRows
      //   return currentPageData;
      // };

      onPageChange = (page, pageSize) => {
        const newTotalRecored = (page - 1) * pageSize;
        this.setState(
          {
            currentPage: page,
            totalrecored: newTotalRecored,
          },
          () => {
            this.GetRosterReport()
          }
        );
      };



      getipaNameList = async (isInitialLoad = false) => {
        this.setState({ isLoading: true, showFound: true });
        let axiosConfig = {
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
            Accept: "application/json",
            "Content-type": "application/json",
          },
        };
        let Roles = sessionStorage.getItem("rolename");
        let requestedNpis = [];
    
        if (Roles.includes("Provider")) {
          //console.log(" profiver if 2222222")
          let tempArr = JSON.parse(sessionStorage.getItem("npivalue"));
          requestedNpis.push(...tempArr);
        }
        if (Roles.includes("Group User") || Roles.includes("IPA User")) {
          let taxNpiMapping = JSON.parse(
            sessionStorage.getItem("rolename").includes("IPA User")
              ? sessionStorage.getItem("latestTaxidNpiMapping")
              : sessionStorage.getItem("taxidNpiMapping")
          );
          if (taxNpiMapping && taxNpiMapping.length > 0) {
            taxNpiMapping.map((item) => {
              if (item.NPI) {
                item.NPI.map((npi) => {
                  if (!requestedNpis.includes(npi)) {
                    requestedNpis.push(npi);
                  }
                });
              }
            });
          }
        }
        // setState({ accessNpis: requestedNpis })
        let npis = [];

        // Abort previous NPI request
        if (this.npiController) {
          console.log("Aborting previous ListNPIBasedOnPlan...");
          this.npiController.abort();
        }

        // Create new controller
        const controller = new AbortController();
        this.npiController = controller;
        
        if (!isInitialLoad && (sessionStorage.getItem("planName") !== "solis") || (!Roles.includes("IPA User") && !Roles.includes("Plan Admin"))) {
          axios
            .post(
              `${Config.api}/ListNPIBasedOnPlan?PlanName=${sessionStorage.getItem(
                "planName"
              )}`,
              { NpiNumber: requestedNpis },
              {
                ...axiosConfig,
                signal: this.npiController.signal,
              }
              
            )
            .then((res) => {
              // setState({
              //   dataLoader: true
              // })
              if (
                controller.signal.aborted ||
                this.npiController !== controller
              ) {
                console.log("Ignoring old NPI response");
                return;
              }
        
              console.log("ListNPIBasedOnPlan response received");
              let npiList = res.data.Details;
              let tempNameArr = {};
              let count = 0;
              let tempNpiMap = new Map();
              for (let i = 0; i < npiList.length; i++) {
                if (npiList[i].providerType === "PCP") {
                  let name = npiList[i].lastName
                    ? `${npiList[i].lastName}${
                        npiList[i].middleName ? " " + npiList[i].middleName : ""
                      } ${npiList[i].firstName}`
                    : npiList[i].facilityName;
              
                  const npi = npiList[i].npiNumber;
              
                  if (!tempNpiMap.has(npi)) {
                    tempNpiMap.set(npi, {
                      npinumber: npi,
                      FullName: name,
                      providerTaxId: npiList[i].groupTaxId,
                    });
                  }
                }
              }
              npis = Array.from(tempNpiMap.values());
              if (npis.length > 1) {
                if (npis[0].FullName === npis[1].FullName) {
                  let temp = npis.shift();
                  npis[0].npinumber += "," + temp.npinumber;
                }
              }
              if (npis.length > 1)
                npis.splice(0, 0, {
                  npinumber: "Select All",
                  FullName: "Select All",
                  providerTaxId:"Select All"
                });
                console.log(npis)
              this.setState({
                providernameList: npis, //npis.map((i) => JSON.stringify(i)),
                isLoading: false,
                providerLoader: false,
              });
            })
            .catch((error) => {
              if (
                axios.isCancel(error) ||
                error.code === "ERR_CANCELED"
              ) {
                console.log("ListNPIBasedOnPlan API aborted");
                return;
              }
        
              console.error("NPI API error:", error);
            });
        }
        const isSolisGroupUser =
          sessionStorage.getItem("planName") === "solis" &&
          Roles.includes("Group User");
        if (
          (
          !Roles.includes("Provider") &&
          !isSolisGroupUser &&
            (
          sessionStorage.getItem("planName").includes("ultimate") ||
          sessionStorage.getItem("planName").includes("solis") ||
          sessionStorage.getItem("planName").includes("demo") ||  sessionStorage.getItem("planName").includes("csh") ||
          sessionStorage.getItem("planName").includes("secur")
            )
          )
        ) {
          const planName = sessionStorage.getItem("planName");
          const ipaList =
            [sessionStorage.getItem("IPAList")] == ""
              ? []
              : sessionStorage
                  .getItem("IPAList")
                  .match(/(".*?"|[^,]+)(?=\s*,|\s*$)/g)
                  .map(function (item) {
                    return item.replace(/"/g, "");
                  });
          let TaxidNPIFilter = {};
          if (sessionStorage.getItem("rolename").includes("Group User")) {
            let taxNpiMapping = JSON.parse(
              sessionStorage.getItem("taxidNpiMapping")
            );
            if (taxNpiMapping && taxNpiMapping.length > 0) {
              let taxIDs = [];
              let npis = [];
              taxNpiMapping.map((item) => {
                if (item.TaxID) {
                  taxIDs.push(item.TaxID);
                }
                if (item.NPI) {
                  item.NPI.map((npi) => {
                    npis.push(npi);
                  });
                }
              });
    
              TaxidNPIFilter["ProviderNPI"] = npis.join(",");
              TaxidNPIFilter["PCPTaxId"] = taxIDs.join(",");
            }
          }
          const res = await axios.post(
            Config.Providerapi + "/GetListofIPA",
            {
              PlanName: planName,
              IPAList: ipaList,
              TaxidNPIFilter: TaxidNPIFilter,
            },
            axiosConfig
          );
          // .then((res) => {
          //console.log(res);
          let array = res.data.IPADetails;
    
          let finalList = [];
    
          if (sessionStorage.getItem("planName") == "solis") {
            array.map((item) => {
    
              if (item.ipa && !finalList.includes(item.ipa.toUpperCase())) {
                if (item.msoid !== null) {
    
                  finalList.push({
    
                    ipaName: item.ipa.toUpperCase(),
                    value: item.msoid,
    
                  });
                }
              }
            });
          } else {
            array.map((item) => {
              if (item.ipa && !finalList.includes(item.ipa.toUpperCase())) {
                if (item.ipa !== null) {
                  finalList.push({
                    ipaName: item.ipa.toUpperCase(),
                    value: item.ipa.toUpperCase(), // MSOID is only for SOLIS as of now
                  });
                }
              }
            });
          }
    
          if (
            finalList.length > 1 
          ) {
            finalList.splice(0, 0, {
              ipaName: "Select All".toUpperCase(),
              value: "Select All".toUpperCase(),
            });
          }
    
          this.setState({
            ipaNameList: finalList,
            isLoading: false,
          });
          // })
          // .catch((err) => {
          //   console.log(err);
          // });
        }
    
        if (
          sessionStorage.getItem("planName").includes("solis") &&
           !sessionStorage.getItem("rolename").includes("Group User")
        ) {
          this.setState({
            payeeLoader: true,
          });
          console.log(" else if condition 1231212");
          let searchParams = [];
          const ipaList =
            [sessionStorage.getItem("IPAList")] == ""
              ? []
              : sessionStorage
                  .getItem("IPAList")
                  .match(/(".*?"|[^,]+)(?=\s*,|\s*$)/g)
                  .map(function (item) {
                    return item.replace(/"/g, "");
                  });
          if (Roles.includes("Plan Admin")) {
            searchParams.push({
              fieldName: "cprstatus",
              fieldValue: "A",
            });
          }
          ipaList.forEach((ipa) => {
            searchParams.push({
              fieldName: "ipaname",
              fieldValue: ipa,
            });
          });
          axios
            .post(
              `${Config.Providerapi}/GetProviderBasedOnMSOID`,
              {
                SearchParameters: [...searchParams],
                PlanName: sessionStorage.getItem("planName"),
                IsMSOSelectAll: false,
                MSOIds: "",
              },
              axiosConfig
            )
            .then((res) => {
              //console.log("res data 222",res)
              let array = res.data.Details; 
              let uniquePayeenameList = [];
              let payeenameSet = new Set();
              
    
              uniquePayeenameList.unshift({ Payeename: "Select All" });
              // console.log("uniquePayeenameList",uniquePayeenameList)
              //let PayeenameList = [];
              let finalList = [];
              let newArray = array.map((item) => {
                return {
                  npinumber: item.npinumber,
                  FullName: `${item.lastname} ${item.firstname}`,
                  providerTaxId: item.providertaxid
                };
              });
              console.log("NewArray-1: ", newArray);
              const uniqueList = [
                ...newArray
                  .reduce((map, obj) => map.set(obj.npinumber, obj), new Map())
                  .values(),
              ];
              //console.log("uniqueList: ", uniqueList);
              array.map((item) => {
                if (
                  item.ipaname &&
                  !finalList.includes(item.ipaname.toUpperCase())
                ) {
                  finalList.push({
                    ipaName: item.ipa.toUpperCase(),
                    value: item.msoid,
                  });
                }
                
              });
              //console.log("PayeenameList",PayeenameList)
              if (uniqueList.length > 1)
                uniqueList.splice(0, 0, {
                  npinumber: "Select All",
                  FullName: "Select All",
                  providerTaxId: "Select All"
                });
              // if (finalList.length > 1) finalList.splice(0, 0, "Select All")
              // console.log("finalList",finalList)
              this.setState(
                {
                  providernameList: uniqueList,
                  providerLoader: false,
                  payeenameList: uniquePayeenameList,
                  isLoading: false,
                  showFound: true,
                  payeeLoader: false,
                },
                () => {
                  // console.log("Updated state: ", this.state.providernameList);
                  // console.log("loader: ", this.state.providerLoader);
                }
              );
            })
            .catch((err) => {
              this.setState({
                isLoading: false,
              });
              // console.log("Something went wrong...");
            });
        }
      };
      

      downloadInPDF = async () => {
        this.setState({
          DwonloadRosterlodar:true
        })
      this.GetRosterReportDownload("PDF")
      };


      downloadInExcel = () => {
        this.setState({
          DwonloadRosterlodar:true
        })
        this.GetRosterReportDownload("EXCEL")
      };


     
      GetRosterReportDownload(formate){
        console.log("crete report")
        // console.log( this.state.providerTaxIdList)
        // console.log( this.state.providerNpiList)
         console.log("ipa list",this.state.ipaNameList)
         console.log("asdasd", this.props.form.getFieldValue("providerTaxId"))
        let selectedTaxIds = this.props.form.getFieldValue("providerTaxId");
        let selectedNPI = this.props.form.getFieldValue("providerNPI");
        let selectedProviderName= this.props.form.getFieldValue("providername");
        let selectedNPIString = Array.isArray(selectedNPI)
          ? selectedNPI.map(String)
          : [];

        let ipaArray = [];

        if (this.state.selIpaNames.includes("SELECT ALL")) {
          ipaArray = this.state.ipaNameList
            .filter(item => item.ipaName !== "SELECT ALL")
            .map(item => item.ipaName);
        } else {
          if( sessionStorage.getItem("planName") === "solis"){
            ipaArray = this.state.selIpaNames.flat();

             ipaArray = this.state.ipaNameList
              .filter(item => ipaArray.includes(item.value))
              .map(item => item.ipaName);

            console.log(ipaArray);

          }else{
          ipaArray = this.state.selIpaNames;
          }
        }

        let providerName = [];

        if (
          selectedProviderName.some(
            item => JSON.parse(item).FullName === "Select All"
          )
        ) {
          providerName = this.state.providernameList
            .filter(item => item.FullName !== "Select All")
            .map(item => item.FullName);
        } else {
          providerName = selectedProviderName.map(
            item => JSON.parse(item).FullName
          );
        }
        
        console.log(providerName);

        // let providerName = selectedProviderName.map(item => JSON.parse(item).FullName);
           let axiosConfig = {
            headers: {
              Authorization: sessionStorage.getItem("access_token"),
              Accept: "application/json",
              "Content-type": "application/json",
            },
          };
          let params = {
            "planName": sessionStorage.getItem("planName"),
            "isProviderType": "PCP",
            "ipa": ipaArray,
            "providerName": providerName,
            "taxID": this.state.selTaxid,
            "npi": this.state.selnpi,
            "pageNumber": 1,
            "pageSize": this.state.TotalCount,
          } 
          axios
            .post(`${Config.api}/GetCSHWebsiteAndMemberPortal`, params, axiosConfig)
            .then((response) => {
              console.log(response.data)
              this.setState({
                DwonloadRosterReport:response.data,
                DwonloadRosterlodar:false
              })

              
              if(formate == "PDF") {
                const doc = new jsPDF({
                  orientation: "landscape",
                  unit: "in",
                  format: [20, 10],
                });
                
                const today = new Date();
                
                // Check if logged-in user is Plan Admin
                const isPlanAdmin = (sessionStorage.getItem("rolename") || "")
                  .split(",")
                  .map(role => role.trim())
                  .includes("Plan Admin");
                
                // Logo
                let logoImage = new Image();
                logoImage.src = mirranew;
                
                const PdfBody = this.state.DwonloadRosterReport.map((item) => {
                  const basic = item.basicDetails || {};
                  const specialty = basic.specialties?.[0] || {};
                  const location = basic.practiceLocation?.[0] || {};
                  const hours = location.hoursOfOperation?.[0] || {};
                
                  const row = [
                    location.practitionerStatus || "", // Practitioner Status
                    basic.lastName || "", // Last Name
                    basic.firstName || "", // First Name
                    basic.middleName || "", // Middle Name
                    basic.suffixName || "", // Suffix Name
                    location.groupTaxId || "", // Tax ID
                    basic.npiNumber || "", // Individual NPI
                    location.groupNPI || "", // Group NPI
                    basic.deaNumber || "", // DEA Number
                    basic.dateOfBirth || "", // Date of Birth
                    basic.gender || "", // Gender
                    basic.language || "", // Spoken Language(s)
                    basic.canSpeakAmericanSignLanguage || "", // American Sign Language
                    basic.boardAccred || "", // Board Accredited
                    basic.practitionerTypeName || "", // Practitioner Type
                    specialty.specialtyName || "", // Specialty Type
                    specialty.taxonomyCode || "", // Taxonomy Code
                  ];
                
                  // Add Provider Effective Date only for Plan Admin
                  if (isPlanAdmin) {
                    row.push(basic.effectiveDate || "");
                  }
                
                  // Remaining columns
                  row.push(
                    basic.hospitalAffiliation || "",
                    basic.inDirectory || "",
                    location.addressTypeName || ""
                  );
                
                  return row;
                });
                
                // Table Header
                const header = [[
                  "Practitioner Status",
                  "Last Name",
                  "First Name",
                  "Middle Name",
                  "Suffix Name",
                  "Tax ID",
                  "Individual NPI",
                  "Group NPI",
                  "DEA Number",
                  "Date of Birth",
                  "Gender",
                  "Spoken Language(s)",
                  "American Sign Language",
                  "Board Accredited",
                  "Practitioner Type",
                  "Specialty Type",
                  "Taxonomy Code",
                  ...(isPlanAdmin ? ["Provider Effective Date"] : []),
                  "Hospital Affiliation",
                  "Provider to show in Directory",
          
                ]];
                
                doc.autoTable({
                  head: header,
                  body: PdfBody,
                  startY: 0.7,
                  styles: {
                    fontSize: 7,
                    cellPadding: 0.05,
                    halign: "center",   // Center body text horizontally
                    valign: "middle",   // Optional: Center vertically
                  },
                  headStyles: {
                    fillColor: [66, 139, 202],
                    textColor: [255, 255, 255],
                    halign: "center",
                    valign: "middle",
                  },
                  didDrawPage: function (data) {
                    // Logo
                    doc.addImage(
                      logoImage,
                      "PNG",
                      data.settings.margin.left,
                      0.1,
                      0.45,
                      0.45
                    );
                
                    // Date
                    const formattedDate = `${String(today.getMonth() + 1).padStart(
                      2,
                      "0"
                    )}-${String(today.getDate()).padStart(
                      2,
                      "0"
                    )}-${today.getFullYear()}`;
                
                    doc.setFontSize(12);
                    doc.setTextColor(105, 105, 106);
                
                    doc.text(
                      `Date: ${formattedDate}`,
                      18,
                      data.settings.margin.top - 0.2
                    );
                  },
                });
                
                doc.save("Roster Report.pdf");
              }
              else {
                let option = {};
              
                const roles = (sessionStorage.getItem("rolename") || "")
                  .split(",")
                  .map((role) => role.trim());
              
                const isPlanAdmin = roles.includes("Plan Admin");
              
                // ==========================================
                // TAB 1 - Existing Roster Report
                // ==========================================
                const dataTable = this.state.DwonloadRosterReport.map((item) => {
                  const basic = item.basicDetails || {};
                  const specialty = basic.specialties?.[0] || {};
                  const location = basic.practiceLocation?.[0] || {};
                  const hours = location.hoursOfOperation?.[0] || {};
              
                  return {
                    "Practitioner Status": location.practitionerStatus || "",
                    "Last Name": basic.lastName || "",
                    "First Name": basic.firstName || "",
                    "Middle Name": basic.middleName || "",
                    "Suffix Name": basic.suffixName || "",
                    "Tax ID": location.groupTaxId || "",
                    "Individual NPI": basic.npiNumber || "",
                    "Group NPI": location.groupNPI || "",
                    "DEA Number": basic.deaNumber || "",
                    "Date of Birth": basic.dateOfBirth || "",
                    "Gender": basic.gender || "",
                    "Spoken Language(s)": basic.language || "",
                    "American Sign Language":
                      basic.canSpeakAmericanSignLanguage || "",
                    "Board Accredited": basic.boardAccred || "",
                    "Practitioner Type": basic.practitionerTypeName || "",
                    "Specialty Type": specialty.specialtyName || "",
                    "Taxonomy Code": specialty.taxonomyCode || "",
              
                    ...(isPlanAdmin
                      ? {
                          "Provider Effective Date": basic.effectiveDate || "",
                        }
                      : {}),
              
                    "Hospital Affiliation": basic.hospitalAffiliation || "",
                    "Provider to show in Directory": basic.inDirectory || "",
                  };
                });
              
                // ==========================================
                // TAB 2 - Complete Provider Data + Address
                // ==========================================
                const addressDataTable = this.state.DwonloadRosterReport.flatMap(
                  (item) => {
                    const basic = item.basicDetails || {};
                    const specialty = basic.specialties?.[0] || {};
                    const locations = basic.practiceLocation || [];
              
                    // If provider has no location
                    if (locations.length === 0) {
                      return [
                        {
                          "Practitioner Status": "",
                          "Last Name": basic.lastName || "",
                          "First Name": basic.firstName || "",
                          "Middle Name": basic.middleName || "",
                          "Suffix Name": basic.suffixName || "",
                          "Tax ID": "",
                          "Individual NPI": basic.npiNumber || "",
                          "Group NPI": "",
                          "DEA Number": basic.deaNumber || "",
                          "Date of Birth": basic.dateOfBirth || "",
                          "Gender": basic.gender || "",
                          "Spoken Language(s)": basic.language || "",
                          "American Sign Language":
                            basic.canSpeakAmericanSignLanguage || "",
                          "Board Accredited": basic.boardAccred || "",
                          "Practitioner Type": basic.practitionerTypeName || "",
                          "Specialty Type": specialty.specialtyName || "",
                          "Taxonomy Code": specialty.taxonomyCode || "",
              
                          ...(isPlanAdmin
                            ? {
                                "Provider Effective Date":
                                  basic.effectiveDate || "",
                              }
                            : {}),
              
                          "Hospital Affiliation":
                            basic.hospitalAffiliation || "",
                          "Provider to show in Directory":
                            basic.inDirectory || "",
              
                          // Address fields
                          "Location Effective Date": "",
                          "Location End Date": "",
                          "Location Name": "",
                          "Address Line 1": "",
                          "Address Line 2": "",
                          "City": "",
                          "State": "",
                          "Zip Code": "",
                          "County": "",
                          "Telephone Number": "",
                          "Fax Number": "",
                          "DBA": "",
                          "Accepting New Patients": "",
                          "Hours of Operation": "",
                          "Website": "",
                          "Location to show in Directory": "",
                        },
                      ];
                    }
              
                    // Provider with one or multiple locations
                    return locations.map((location) => {
                      const hours = location.hoursOfOperation?.[0] || {};
              
                      return {
                        // ==========================================
                        // Provider Information
                        // ==========================================
                        "Practitioner Status":
                          location.practitionerStatus || "",
              
                        "Last Name": basic.lastName || "",
                        "First Name": basic.firstName || "",
                        "Middle Name": basic.middleName || "",
                        "Suffix Name": basic.suffixName || "",
              
                        "Tax ID": location.groupTaxId || "",
              
                        "Individual NPI": basic.npiNumber || "",
              
                        "Group NPI": location.groupNPI || "",
              
                        "DEA Number": basic.deaNumber || "",
              
                        "Date of Birth": basic.dateOfBirth || "",
              
                        "Gender": basic.gender || "",
              
                        "Spoken Language(s)": basic.language || "",
              
                        "American Sign Language":
                          basic.canSpeakAmericanSignLanguage || "",
              
                        "Board Accredited": basic.boardAccred || "",
              
                        "Practitioner Type":
                          basic.practitionerTypeName || "",
              
                        "Specialty Type":
                          specialty.specialtyName || "",
              
                        "Taxonomy Code":
                          specialty.taxonomyCode || "",
              
                        ...(isPlanAdmin
                          ? {
                              "Provider Effective Date":
                                basic.effectiveDate || "",
                            }
                          : {}),
              
                        "Hospital Affiliation":
                          basic.hospitalAffiliation || "",
              
                        "Provider to show in Directory":
                          basic.inDirectory || "",
              
                        // ==========================================
                        // Address / Location Information
                        // ==========================================
                        "Location Effective Date":
                          location.locationEffDt || "",
              
                        "Location End Date":
                          location.locationTrmDt || "",
              
                        "Location Name":
                          location.locationName || "",
              
                        "Address Line 1":
                          location.lineNumber1 || "",
              
                        "Address Line 2":
                          location.lineNumber2 || "",
              
                        "City":
                          location.city || "",
              
                        "State":
                          location.state || "",
              
                        "Zip Code":
                          location.zipCode || "",
              
                        "County":
                          location.county || "",
              
                        "Telephone Number":
                          location.phone || "",
              
                        "Fax Number":
                          location.fax || "",
              
                        "DBA":
                          location.practiceLocationCorporateName || "",
              
                        "Accepting New Patients":
                          hours.acceptingPatients || "",
              
                        "Hours of Operation":
                          location.hoursOfOperation[0].acceptingPatients || "",
                  
                        "Website":
                          location.website || "",
              
                        "Location to show in Directory":
                          hours.inDirectory || "",
              
                      };
                    });
                  }
                );
              
                // ==========================================
                // Excel File
                // ==========================================
              
                option.fileName = "Roster Report";
              
                option.datas = [
                  // ==========================================
                  // TAB 1
                  // ==========================================
                  {
                    sheetData: dataTable,
                    sheetName: "Roster Report",
              
                    sheetHeader: [
                      "Practitioner Status",
                      "Last Name",
                      "First Name",
                      "Middle Name",
                      "Suffix Name",
                      "Tax ID",
                      "Individual NPI",
                      "Group NPI",
                      "DEA Number",
                      "Date of Birth",
                      "Gender",
                      "Spoken Language(s)",
                      "American Sign Language",
                      "Board Accredited",
                      "Practitioner Type",
                      "Specialty Type",
                      "Taxonomy Code",
              
                      ...(isPlanAdmin
                        ? ["Provider Effective Date"]
                        : []),
              
                      "Hospital Affiliation",
                      "Provider to show in Directory",
                    ],
                  },
              
                  // ==========================================
                  // TAB 2
                  // ==========================================
                  {
                    sheetData: addressDataTable,
                    sheetName: "Roster + Address",
              
                    sheetHeader: [
                      // Provider information
                      "Practitioner Status",
                      "Last Name",
                      "First Name",
                      "Middle Name",
                      "Suffix Name",
                      "Tax ID",
                      "Individual NPI",
                      "Group NPI",
                      "DEA Number",
                      "Date of Birth",
                      "Gender",
                      "Spoken Language(s)",
                      "American Sign Language",
                      "Board Accredited",
                      "Practitioner Type",
                      "Specialty Type",
                      "Taxonomy Code",
              
                      ...(isPlanAdmin
                        ? ["Provider Effective Date"]
                        : []),
              
                      "Hospital Affiliation",
                      "Provider to show in Directory",
              
                      // Address information
                      "Location Effective Date",
                      "Location End Date",
                      "Location Name",
                      "Address Line 1",
                      "Address Line 2",
                      "City",
                      "State",
                      "Zip Code",
                      "County",
                      "Telephone Number",
                      "Fax Number",
                      "DBA",
                      "Accepting New Patients",
                      "Hours of Operation",
                      "Website",
                      "Location to show in Directory",
                    ],
                  },
                ];
              
                let toExcel = new ExportJsonExcel(option);
                toExcel.saveExcel();
              }

            })
            .catch((err) => {
              this.setState({
                DwonloadRosterReport:[],
                DwonloadRosterlodar:true
              })
            });
      }
    



      GetRosterReport(){

        console.log("crete report")
      
       this.setState({
        reportLoading: true,
        ApiData:[],
        TotalCount:0
       })
        // console.log( this.state.providerTaxIdList)
        // console.log( this.state.providerNpiList)
        //  console.log("ipa list",this.state.ipaNameList)
         console.log("asdasd", this.props.form.getFieldValue("providerTaxId"))
        let selectedTaxIds = this.props.form.getFieldValue("providerTaxId");
        let selectedNPI = this.props.form.getFieldValue("providerNPI");
        let selectedProviderName= this.props.form.getFieldValue("providername");


        // console.log("selected IPANAME", this.state.selIpaNames)
        // console.log("Slected provifer name",selectedProviderName);
        //    console.log("selected TAX id",selectedTaxIds);
        //    console.log("selected NPI",selectedNPI);
        //console.log("ipa list",this.state.ipaNameList)
        let selectedNPIString = Array.isArray(selectedNPI)
          ? selectedNPI.map(String)
          : [];

        let ipaArray = [];

        if (this.state.selIpaNames.includes("SELECT ALL")) {
          ipaArray = this.state.ipaNameList
            .filter(item => item.ipaName !== "SELECT ALL")
            .map(item => item.ipaName);
        } else {
          if( sessionStorage.getItem("planName") === "solis"){
            ipaArray = this.state.selIpaNames.flat();

             ipaArray = this.state.ipaNameList
              .filter(item => ipaArray.includes(item.value))
              .map(item => item.ipaName);

            console.log(ipaArray);

          }else{
          ipaArray = this.state.selIpaNames;
          }
        }

        let providerName = [];

        if (
          selectedProviderName.some(
            item => JSON.parse(item).FullName === "Select All"
          )
        ) {
          providerName = this.state.providernameList
            .filter(item => item.FullName !== "Select All")
            .map(item => item.FullName);
        } else {
          providerName = selectedProviderName.map(
            item => JSON.parse(item).FullName
          );
        }
        
        console.log(providerName);

        // let providerName = selectedProviderName.map(item => JSON.parse(item).FullName);
           let axiosConfig = {
            headers: {
              Authorization: sessionStorage.getItem("access_token"),
              Accept: "application/json",
              "Content-type": "application/json",
            },
          };
          let params = {
            "planName": sessionStorage.getItem("planName"),
            "isProviderType": "PCP",
            "ipa": ipaArray,
            "providerName": providerName,
            "taxID": this.state.selTaxid,
            "npi": this.state.selnpi,
            "pageNumber": this.state.currentPage,
            "pageSize": this.state.rowsPerPage,
          } 
          axios
            .post(`${Config.api}/GetCSHWebsiteAndMemberPortal`, params, axiosConfig)
            .then((response) => {
              console.log(response.data)
              this.setState({
                ApiData:response.data,
                reportLoading: false,
                TotalCount:response.data[0].basicDetails.count
              })

            })
            .catch((err) => {
              this.setState({
                reportLoading: false,
              })
            });
      }


      handleReset = (clearFilters) => {
        console.log(clearFilters)
        this.props.form.resetFields();
        this.setState({
          searchText: "" ,
          selProviders: [],
          selIpaNames: [],
          selProviderNames:[],
          providerTaxIdList:[],
          providerNpiList:[],
          rowsPerPage: 15,
          currentPage: 1,
          totalrecored: 0,
          enableGenrateButton: false,
          ApiData:[],
          TotalCount:0,
          selectedTaxIds1:[],
          selectedNPIs:[],
          selnpi:[],

        });

        this.props.form.setFieldsValue({
          providerTaxId: [],
          providerNPI:[]
        });
        this.getipaNameList(true);  
    
      };

      getTableData = () => {
        let data  = this.state.ApiData
  
        return data.map((item, index) => {
          const d = item.basicDetails;
          const loc = d.practiceLocation?.[0] || {};
    
          return {
            key: index,
            practitionerStatus: loc.practitionerStatus,
            lastName: d.lastName,
            firstName: d.firstName,
            middleName: d.middleName,
            suffixName: d.suffixName,
            taxId: loc.groupTaxId,
            individualNPI: d.npiNumber,
            groupNPI: loc.groupNPI,
            deaNumber: d.deaNumber,
            dateOfBirth: d.dateOfBirth,
            gender: d.gender,
            spokenLanguages: d.language,
            americanSignLanguage: d.canSpeakAmericanSignLanguage,
            boardAccredited: d.boardAccred,
            practitionerType: d.practitionerTypeName,
            specialtyType: d.specialties?.[0]?.specialtyName,
            taxonomyCode: d.specialties?.[0]?.taxonomyCode,
            providerEffectiveDate: loc.locationEffDt,
            hospitalAffiliation: loc.hoursOfOperation?.[0]?.hospitalAffiliation,
            showInDirectory: loc.hoursOfOperation?.[0]?.inDirectory,
            addressType: loc.addressTypeName
          };
        });
      };
      
      getFilteredData = () => {
        const { filters } = this.state;
        const tableData = this.getTableData();
    
        return tableData.filter((row) =>
          Object.keys(filters).every((key) =>
            row[key]?.toString().toLowerCase().includes(filters[key])
          )
        );
      };

      // New code
  onIpaNameChange = (value) => {
    console.log("value",value)
    console.log("selpayeename", this.state.selpayeename)
    console.log("selProviders", this.state.selProviders)
    this.props.form.setFieldsValue({
      providerTaxId: [],
      providerNPI:[],
      
    });
    this.setState({
      selTaxid:[],
      selnpi:[],
    })
    if (typeof value == "string") {
      value = [value];
    }
    value = value.map((v) => v.toUpperCase());
    const sSelectAll = "SELECT ALL".toUpperCase();
    //console.log("Selected Value: ", value);

    this.setState({
      enableGenrateButton: value.length > 0 ? true : false,
    });
    let updatedList;
    // since multiselect in ipa list is removed the below conditions are not required
    if (
      (value[0] == sSelectAll && value.length == 1) ||
      (value[value.length - 1] == sSelectAll && value.length > 1)
    ) {
      // console.log("here 0");
      updatedList = [];
      updatedList = [sSelectAll];
    } else if (value[0] == sSelectAll && value.length > 1) {
      //console.log("here 02");
      updatedList = [];
      updatedList = value.filter((x) => x != sSelectAll);
    } else if (
      !value.includes(sSelectAll) &&
      this.state.selIpaNames.includes(sSelectAll)
    ) {
      //console.log("here 1");
      updatedList = value.filter((x) => x != sSelectAll);
    } else if (
      !value.includes(sSelectAll) &&
      value.length === this.state.ipaNameList.length - 1
    ) {
      //console.log("here 2");
      updatedList = value; //this.state.ipaNameList;
    } else if (
      this.state.selIpaNames.includes(sSelectAll) &&
      value.includes(sSelectAll) &&
      value.length < this.state.ipaNameList.length
    ) {
      //console.log("here 3");
      //updatedList = value
      updatedList = [];
      updatedList = value.filter((item) => {
        if (item.value != sSelectAll) {
          return item.value;
        }
      });
    } else if (value.includes(sSelectAll)) {
      //console.log("here 4");
      updatedList = value; //this.state.ipaNameList.map((ipa) => ipa.value);
    } else {
      // console.log("here 5");
      updatedList = value;
    }
    //updatedList = updatedList.filter((l) => l !== sSelectAll);
    console.log("updated list", updatedList);
    this.setState(
      {
        providernameList: [],
        showFound: true,
        // payeeLoader:true,
        selIpaNames: updatedList,
        selProviders: [],
        payeenameList: [],
        selpayeename: [],
        taxIdList: [],
        npiList: [],
        providerTaxIdList: [],
        providerNpiList: [],
      },
      () => {
        this.props.form.setFieldsValue({ providername: [] });
        if (
          this.state.providernameList.length === 0 &&
          this.state.selIpaNames.length > 0
        ){
          console.log("Calling getProviderNameList");
          this.getProviderNameList(updatedList);
        }
      }
    );
     this.setState({

      taxIdList:[],
      npiList:[],
      providerTaxIdList:[],
      providerNpiList:[],

     })
    return updatedList;
  };

  getProviderNameList = async (values) => {
    // console.log(values)
    // plan Admin, GU, IPA user
    // let ipaname = values ? values.filter((item) => item != "Select All") : []
    //console.log("Value passed to getProvderNameList", values);

    let Roles = sessionStorage.getItem("rolename");
    let requestedNpis = [];
    if (
      sessionStorage.getItem("planName") === "solis" &&
      Roles.includes("Provider")
    ) {
      this.setState({
        providerLoader: true,
      });
      let axiosConfig = {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
          Accept: "application/json",
          "Content-type": "application/json",
        },
      };
      //let Roles = sessionStorage.getItem("rolename");
      requestedNpis = [];

      if (Roles.includes("Provider")) {
        let tempArr = JSON.parse(sessionStorage.getItem("npivalue"));
        requestedNpis.push(...tempArr);
      }

      if (Roles.includes("Group User") || Roles.includes("IPA User")) {
        // console.log("IPAs", this.ipaNameList);
        let taxNpiMapping = JSON.parse(
          sessionStorage.getItem("rolename").includes("IPA User")
            ? sessionStorage.getItem("latestTaxidNpiMapping")
            : sessionStorage.getItem("taxidNpiMapping")
        );
        if (taxNpiMapping && taxNpiMapping.length > 0) {
          taxNpiMapping.map((item) => {
            if (item.NPI) {
              item.NPI.map((npi) => {
                if (!requestedNpis.includes(npi)) {
                  requestedNpis.push(npi);
                }
              });
            }
          });
        }
      }

      // setState({ accessNpis: requestedNpis })
      let npis = [];

      axios
        .post(
          `${Config.api}/ListNPIBasedOnPlan?PlanName=${sessionStorage.getItem(
            "planName"
          )}`,
          { NpiNumber: requestedNpis },
          axiosConfig
        )
        .then((res) => {
          // setState({
          //   dataLoader: true
          // })
          //console.log("afasdas", res);
          let npiList = res.data.Details;
          let tempNameArr = {};
          let count = 0;
          for (var i = 0; i < npiList.length; i++) {
            if (npiList[i].providerType === "PCP") {
              let name = npiList[i].firstName
                ? `${npiList[i].firstName}${
                    npiList[i].middleName ? " " + npiList[i].middleName : ""
                  } ${npiList[i].lastName}`
                : npiList[i].facilityName;
              if (!tempNameArr[name]) {
                tempNameArr[name] = count;
                npis.push({
                  npinumber: npiList[i].npiNumber,
                  FullName: name,
                  providerTaxId: npiList[i].groupTaxId, // Added providerTaxId
                });
                count++;
              } else {
                npis[tempNameArr[name]].npinumber += "," + npiList[i].NPINumber;
              }
            }
          }
          if (npis.length > 1) {
            if (npis[0].FullName === npis[1].FullName) {
              let temp = npis.shift();
              npis[0].npinumber += "," + temp.npinumber;
            }
          }
          if (npis.length > 1)
            npis.splice(0, 0, {
              npinumber: "Select All",
              FullName: "Select All",
              providerTaxId: "Select All"
            });
          this.setState({
            providernameList: npis,
            providerLoader: false,
          });
          //     console.log("state 11111: ", this.state.providernameList);
          // console.log("loader 11111: ", this.state.providerLoader);
        })
        .catch((er) => {
          // console.log("er", er);
        });
      
    } else {
      let Roles = sessionStorage.getItem("rolename");
      // let ipaname = [values];
      let SearchParameters = [];
      // if (ipaname.length > 0 && !Roles.includes("Provider")) {
      //   ipaname.forEach((item) => {
      //     SearchParameters.push({
      //       fieldName: "ipaname",
      //       fieldValue: item,
      //     });
      //   });
      // }

      if (Roles.includes("Provider")) {
        if (sessionStorage.getItem("taxid")) {
          SearchParameters.push({
            fieldName: "taxid",
            fieldValue: JSON.parse(sessionStorage.getItem("taxid"))[0],
          });
        }
        SearchParameters.push({
          fieldName: "npinumber",
          fieldValue: JSON.parse(sessionStorage.getItem("npivalue"))[0],
        });
      }

      if (
        (Roles.includes("Group User") || Roles.includes("IPA User")) &&
        !values
      ) {
        let taxNpiMapping = sessionStorage
          .getItem("rolename")
          .includes("IPA User")
          ? sessionStorage.getItem("latestTaxidNpiMapping")
          : sessionStorage.getItem("taxidNpiMapping");
        if (taxNpiMapping) {
          for (let item of JSON.parse(taxNpiMapping)) {
            if (item.TaxID) {
              SearchParameters.push({
                fieldName: "taxid",
                fieldValue: item.TaxID,
              });
            }
            if (item.NPI && item.NPI.length > 0) {
              item.NPI.map((npi) => {
                SearchParameters.push({
                  fieldName: "npinumber",
                  fieldValue: npi,
                });
              });
            }
          }
        }
      }

      this.setState({
        providernameList: [],
        providerLoader: true,
        selProviders: [],
      });
      let axiosConfig = {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
          Accept: "application/json",
          "Content-type": "application/json",
        },
      };
      if (!values) {
        values = [];
      }
      // The old .map() returned `undefined` for the "SELECT ALL" entry, which
      // could end up as an undefined ipaname in the Search payload.
      // Use filter + map so only real IPA values remain.
      if (values.includes("SELECT ALL")) {
        values = this.state.ipaNameList
        .filter((x) => x.value !== "SELECT ALL")
        .map((x) => x.value);
        }

        const isGroupUserIpaSearch =
          Roles.includes("Group User") &&
          sessionStorage.getItem("planName") !== "solis" &&
          values.length > 0;
      //console.log("Line691:", values);
      let searchParamsObj = {};
      if (
        (Roles.includes("Group User") || Roles.includes("Provider")) &&
        !isGroupUserIpaSearch
      ) {
        await this.getipaNameList();
        //console.log("IPA Name List", this.state.ipaNameList);
        searchParamsObj = {
          SearchParameters: SearchParameters,
          PlanName: sessionStorage.getItem("planName"),
          MSOIds:
            this.state.ipaNameList != undefined
              ? this.state.ipaNameList
                  .map((x) => x.value)
                  .join(", ")
                  .toString()
              : "",
          IsMSOSelectAll: false,
        };
      } else {
        if (sessionStorage.getItem("planName") == "solis") {
          // Remove the  null or undefined value
          const indexToRemove = values.findIndex(item => item == null);
          if (indexToRemove !== -1) {
            values.splice(indexToRemove, 1);
          }
          this.setState({
            selectedIapname: values,
            payeeLoader: true,
          });
          searchParamsObj = {
            SearchParameters: SearchParameters,
            PlanName: sessionStorage.getItem("planName"),
            MSOIds: values.includes("Select All")
              ? values
                  .filter((val) => val != "Select All")
                  .join(", ")
                  .toString()
              : values.join(", ").toString(),
            IsMSOSelectAll: values.includes("Select All") ? true : false,
          };
          let res = await axios.post(
            `${Config.Providerapi}/GetProviderBasedOnMSOID`,
            searchParamsObj,
            axiosConfig
          );

          // .then((res) => {
          //console.log("serach1", res);
          let array = res.data.Details;

          // console.log(array)
          let finalList = [];
          

          let uniquePayeenameList = [];
          let payeenameSet = new Set();

          

          uniquePayeenameList.unshift({ Payeename: "Select All" });
          //console.log("uniquePayeenameList",uniquePayeenameList)
          let newArray = array.map((item) => {
            return {
              npinumber: item.npinumber,
              FullName: `${item.lastname} ${item.firstname} `,
              providerTaxId: item.providertaxid
            };
          });
          console.log("NewArray--22: ", newArray);
          const uniqueList = [
            ...newArray
              .reduce((map, obj) => map.set(obj.npinumber, obj), new Map())
              .values(),
          ];

          if (uniqueList.length > 1)
            uniqueList.splice(0, 0, {
              npinumber: "Select All",
              FullName: "Select All",
              providerTaxId: "Select All"
            });

          if (uniqueList && uniqueList.length > 0) {
            this.setState({
              providernameList: uniqueList,
              providerLoader: false,
              payeeLoader: false,
              payeenameList: uniquePayeenameList,
              isLoading: false,
              showFound: true,
            });
          }
        } else {
          console.log("Other plans");

          let ipaname = values.filter((v) => v !== undefined && v !== null);
          let SearchParameters = [];
          if (ipaname.length > 0 && !Roles.includes("Provider")) {
            ipaname.forEach((item) => {
              SearchParameters.push({
                fieldName: "ipaname",
                fieldValue: item,
              });
            });
          }

          if (Roles.includes("Provider")) {
            if (sessionStorage.getItem("taxid")) {
              SearchParameters.push({
                fieldName: "ProviderTaxId",
                fieldValue: JSON.parse(sessionStorage.getItem("taxid"))[0],
              });
            }
            SearchParameters.push({
              fieldName: "npinumber",
              fieldValue: JSON.parse(sessionStorage.getItem("npivalue"))[0],
            });
          }

          if (
            (Roles.includes("Group User") || Roles.includes("IPA User")) &&
            !values
          ) {
            let taxNpiMapping = sessionStorage
              .getItem("rolename")
              .includes("IPA User")
              ? sessionStorage.getItem("latestTaxidNpiMapping")
              : sessionStorage.getItem("taxidNpiMapping");
            if (taxNpiMapping) {
              for (let item of JSON.parse(taxNpiMapping)) {
                if (item.TaxID) {
                  SearchParameters.push({
                    fieldName: "ProviderTaxId",
                    fieldValue: item.TaxID,
                  });
                }
                if (item.NPI && item.NPI.length > 0) {
                  item.NPI.map((npi) => {
                    SearchParameters.push({
                      fieldName: "npinumber",
                      fieldValue: npi,
                    });
                  });
                }
              }
            }
          }

          
           // Abort ListNPIBasedOnPlan API
  if (this.npiController) {
    console.log("Aborting ListNPIBasedOnPlan...");
    this.npiController.abort();
    this.npiController = null;
  }

          this.setState({
            providernameList: [],
            providerLoader: true,
            selProviders: [],
          });
          let axiosConfig = {
            signal: null,
            headers: {
              Authorization: sessionStorage.getItem("access_token"),
              Accept: "application/json",
              "Content-type": "application/json",
            },
          };
          
          // Cancel previous request if it exists
          if (this.searchController) {
            this.searchController.abort();
          }
          // Create controller BEFORE axios
          const controller = new AbortController();
          // Store the new controller
          this.searchController = controller;
          this.setState({
            providerLoader: true,
          });



          axios
            .post(
              `${Config.Providerapi}/Search`,
              {
                SearchParameters: SearchParameters,
                PlanName: sessionStorage.getItem("planName"),
              },
              {
                ...axiosConfig,
                signal: this.searchController.signal,
              }
            )
            .then((res) => {
              // Make sure this is still the current request
              if (this.searchController !== controller) {
                return;
              }
              console.log("Latest response:", res);
              let array =
                res.data.Details.searchProviderDetailList || [];
          
              let newArray = array.map((item) => ({
                npinumber: item.npinumber,
                FullName: item.fullName,
                providerTaxId: item.providerTaxId,
              }));

              const uniqueList = [
                ...newArray
                  .reduce(
                    (map, obj) => map.set(obj.npinumber, obj),
                    new Map()
                  )
                  .values(),
              ];
          
              if (uniqueList.length > 1) {
                uniqueList.unshift({
                  npinumber: "Select All",
                  FullName: "Select All",
                  providerTaxId: "Select All",
                });
              }
          
              this.setState({
                providernameList: uniqueList,
                providerLoader: false,
                showFound: true,
              });
            })
            .catch((err) => {
              // Axios cancellation
              if (
                err.name === "CanceledError" ||
                err.code === "ERR_CANCELED"
              ) {
                console.log("Previous request aborted");
                return;
              }
          
              console.log("Something went wrong...", err);
          
              this.setState({
                providernameList: [],
                providerLoader: false,
                showFound: true,
              });
            });
        }
      }
    }
  };
 

  openLocationModal = (locations) => {
    console.log(locations)
    const practiceLocations = (locations.practiceLocation || []).map(
      (location) => ({
        ...location,
        website: locations.website || "",
      })
    );
  
    this.setState({
      locationModalVisible: true,
      selectedPracticeLocations: practiceLocations,
    });
  };
  
  closeLocationModal = () => {
    this.setState({
      locationModalVisible: false,
      selectedPracticeLocations: [],
    });
  };

  render() {
    
    //console.log("TotalCount",this.state.TotalCount)
   // const { ApiData } = this.state;
    //console.log(ApiData)
    const ApiData = this.state.ApiData;
    let renderRows = [];
    if (ApiData && ApiData[0]) {
      renderRows = ApiData.map((rows, index) => {
        return rows;
      });
    }
    // console.log( "selIpaNames",this.state.selIpaNames)
    const { getFieldDecorator } = this.props.form;
    let Roles = sessionStorage.getItem("rolename");
    
   
    return (
      <div>
        <Form>
          <div className="square-blue-profile-listuser-1">
            <Row
              className="ml-4"
              type="flex"
              justify-content="space-start"
              align="middle"
              style={{ padding: "6px" }}
            >
              
              
              <Col
                push={sessionStorage.getItem("planName") === "solis" ? 9 : 18}
                className={"ml-4"}
              >
                {/* <NavLink to="/AddUser">
             </NavLink> */}
                
              </Col>
            </Row>
          </div>

          <div   className="square-white-profile-listuser-1 mx-4 px-4 pt-2 pb-4" >
            
            {this.state.TicketShow == true ? (
              <div>
                
              </div>
            ) : (
              <Row>
                {this.state.GroupOrIpaField && (
                    <Col className="" span={6}>
                      <div className="addStaff-text">Group / IPA Name</div>
                      <Form.Item>
                        {getFieldDecorator("ipaname", {
                          getValueFromEvent: this.onIpaNameChange,
                        })(
                          <Select
                            maxTagTextLength={10}
                            size="small"
                            mode="multiple"
                            //mode="multiple"
                            showSearch
                            style={{ width: "18vw" }}
                            placeholder="Select Group / IPA Name(s)"
                            // optionFilterProp="children"
                            value={this.state.selIpaNames}
                            //onChange={(e) => this.onIpaNameChange(e)}
                            className="removeInputBorder"
                            loading={this.state.isLoading}
                            notFoundContent={
                              <div className="nice-message">
                                {this.state.isLoading ? (
                                  <div>Loading....</div>
                                ) : (
                                  <div>No Data Found</div>
                                )}
                              </div>
                            }
                            filterOption={(input, option) =>
                              (option?.children ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {this.state.ipaNameList &&
                              this.state.ipaNameList.map((item, idx) => {
                                if (item) {
                                  return (
                                    <Option
                                      key={idx}
                                      value={item.value}
                                      // style={{ textTransform: "capitalize" }}
                                    >
                                      {item.ipaName}
                                    </Option>
                                  );
                                }
                              })}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  )}

               

                  <Col
                    className=""
                    span={
                      sessionStorage.getItem("planName") === "solis" &&
                        Roles.includes("Provider")
                        ? 8
                        : sessionStorage.getItem("planName") === "solis"
                          ? 6
                          : 6
                    }
                   >
                    <Tooltip
                      title={
                        Roles.includes("Provider") ||
                        (this.state.selIpaNames.length > 0
                          ? ""
                          : "Please select IPA name first" &&
                          sessionStorage.getItem("planName") !== "solis")
                      }
                      placement="topLeft"
                      align="left"
                    >
                      <div
                        className="addStaff-text"
                        style={{ marginBottom: "5px" }}
                      >
                        Provider Name
                      </div>
                      <Form.Item>
                      {getFieldDecorator("providername", {
                        getValueFromEvent: this.onProviderChange,
                        initialValue: [],
                      })(
                        <Select
                        maxTagTextLength={10}
                        size="small"
                        mode="multiple"
                        className="removeInputBorder Fixed-Height"
                        showSearch
                        style={{
                          width:
                            sessionStorage.getItem("planName") === "solis"
                              ? "18vw"
                              : "18vw",
                        }}
                        placeholder="Select Provider Name(s)"
                        loading={this.state.providerLoader}
                        notFoundContent={
                          <div className="nice-message">
                            {this.state.providerLoader ? (
                              <div>Loading....</div>
                            ) : (
                              <div>No Data Found</div>
                            )}
                          </div>
                        }
                      >
                          {this.state.providernameList &&
                            this.state.providernameList.length > 0 &&
                            this.state.providernameList.map((provider, idx) => {
                              if (provider) {
                                // console.log("Rendering provider: ", provider.FullName);
                                return (
                                  <Option
                                    key={idx}
                                    value={JSON.stringify(provider)}
                                  >
                                    {provider.FullName}
                                  </Option>
                                );
                              }
                            })}
                        </Select>
                      )}
                    </Form.Item>
                    </Tooltip>
                  </Col>

                  <Col
  className=""
  span={
    sessionStorage.getItem("planName") === "solis" &&
    Roles.includes("Provider")
      ? 8
      : sessionStorage.getItem("planName") === "solis"
      ? 6
      : 6
  }
>
  <div
    className="addStaff-text"
    style={{ marginBottom: "5px" }}
  >
     Tax ID
  </div>

  <Form.Item>
  {getFieldDecorator("providerTaxId", {
    getValueFromEvent: this.onProviderTaxIdChange,
    initialValue: [],
  })(
    <Select
      maxTagTextLength={10}
      size="small"
      mode="multiple"
      className="removeInputBorder Fixed-Height"
      showSearch
      placeholder="Select Provider Tax ID(s)"
      value={this.state.selectedTaxIds1}
      style={{
        width:
          sessionStorage.getItem("planName") === "solis"
            ? "18vw"
            : "18vw",
      }}
    >
      {this.state.providerTaxIdList &&
        this.state.providerTaxIdList.map((item, idx) => (
          <Option key={idx} value={item.providerTaxId}>
            {item.providerTaxId}
          </Option>
        ))}
    </Select>
  )}
</Form.Item>
</Col>



<Col
  className=""
  span={
    sessionStorage.getItem("planName") === "solis" &&
    Roles.includes("Provider")
      ? 8
      : sessionStorage.getItem("planName") === "solis"
      ? 6
      : 6
  }
>
  <div
    className="addStaff-text"
    style={{ marginBottom: "5px" }}
  >
    NPI
  </div>

  <Form.Item>
  {getFieldDecorator("providerNPI", {
    getValueFromEvent: this.onProviderNPIChange,
    initialValue: [],
  })(
    <Select
      maxTagTextLength={10}
      size="small"
      mode="multiple"
      className="removeInputBorder Fixed-Height"
      showSearch
      placeholder="Select NPI(s)"
      value={this.state.selectedNPIs}
      style={{
        width:
          sessionStorage.getItem("planName") === "solis"
            ? "18vw"
            : "18vw",
      }}
    >
      {this.state.providerNpiList &&
        this.state.providerNpiList.map((item, idx) => (
          <Option key={idx} value={item.npinumber}>
            {item.npinumber}
          </Option>
        ))}
    </Select>
  )}
</Form.Item>
</Col>
               
              </Row>
            )}
          </div>

        </Form>
        {(this.state.selIpaNames.length !== 0 || this.state.selProviders.length !== 0) && (
        <div className="square-white-profile-listuser-nobg-1 ml-4 p-0">
          <Row>

          <Col span={12} >
                {this.state.TotalCount > 0 && (
                  <div>
                    <b>
                      {`${this.state.TotalCount}`}{" "}
                      Members Found
                    </b>
                  </div>
                )}
          </Col>

            <Col span={12} style={{ textAlign: "right" }}>
              <div className="">
                <PrimaryButton
                  className="delete-alluser danger pl-4 pr-4"
                  onClick={() => this.handleReset()}
                  label={"Reset"}
                />
                <PrimaryButton
                  className="button-alluser px-3 mx-1"
                  onClick={() => this.GetRosterReport()}
                  label={"Generate Report"}
                />
              </div>
            </Col>
          </Row>
        </div>)}




        {ApiData && ApiData.length > 0 ? (
                <div className="square-white-profile-listuser-1 ml-4 py-2 px-4" >
                  <Row>
                    <Col className="p-0 tableOverflow">
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="reportHeaderText">#</th>
                            <th className="reportHeaderText">
                            Practitioner Status
                            </th>
                            <th className="reportHeaderText">
                            Last Name
                            </th>
                            <th className="reportHeaderText">First Name</th>
                            <th className="reportHeaderText">Middle Name</th>
                            <th className="reportHeaderText">Suffix Name</th>
                            <th className="reportHeaderText">
                            Tax ID
                            </th>
                            <th className="reportHeaderText">
                            Individual NPI
                            </th>
                            <th className="reportHeaderText">Group NPI</th>
                            <th className="reportHeaderText">DEA Number</th>
                            <th className="reportHeaderText">Date of Birth</th>
                            <th className="reportHeaderText">Gender</th>
                            <th className="reportHeaderText">Spoken Language(s)</th>
                            <th className="reportHeaderText">American Sign Language</th>
                            <th className="reportHeaderText">Board Accredited</th>
                            <th className="reportHeaderText">Practitioner Type</th>
                            <th className="reportHeaderText">Specialty Type</th>
                            <th className="reportHeaderText">Taxonomy Code</th>
                            
                      {sessionStorage.getItem("rolename")?.includes("Plan Admin") && (
                        <th className="reportHeaderText">Provider Effective Date</th>
                      )} 
                            <th className="reportHeaderText">Hospital Affiliation</th>
                            
                            <th className="reportHeaderText">Provider to show in Directory</th>
                            <th className="reportHeaderText">Addresses</th>
                            {/* <th className="reportHeaderText">PCP County </th> */}
                            
                          </tr>
                        </thead>
                        <tbody className="tdata">
                          {ApiData.map((item, index) => {
                              const rowNumber =
                                this.state.totalrecored + index + 1;
                              return (
                                <tr className="tdata">
                                  <td className="tdColor_idx">{rowNumber}</td>
                                  <td className="tdColor">
                                    { item.basicDetails.practiceLocation[0].practitionerStatus}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.lastName}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.firstName}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.middleName}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.suffixName}
                                  </td>
                                  <td className="tdColor">
                                  { item.basicDetails.practiceLocation[0].groupTaxId}
                                  </td>
                                  <td className="tdColor">
                                   {item.basicDetails.npiNumber}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.practiceLocation[0].groupNPI}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.deaNumber}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.dateOfBirth}
                                  </td>

                                   <td className="tdColor">
                                    { item.basicDetails.gender}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.language}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.canSpeakAmericanSignLanguage}
                                  </td>
                                  <td className="tdColor">
                                  { item.basicDetails.boardAccred}
                                  </td>
                                  <td className="tdColor">
                                  { item.basicDetails.practitionerTypeName}
                                  </td>
                                  <td className="tdColor">
                                  { item.basicDetails.specialties[0].specialtyName}
                                  </td>
                                  <td className="tdColor">
                                    { item.basicDetails.specialties[0].taxonomyCode}
                                  </td>
                                  {sessionStorage.getItem("rolename")?.includes("Plan Admin") && (
                                  <td className="tdColor">
                                    { item.basicDetails.effectiveDate}
                                  </td>
                                  )}
                                  <td className="tdColor">
                                  { item.basicDetails.hospitalAffiliation}
                                  </td>
                                  <td className="tdColor">
                                  { item.basicDetails.inDirectory}
                                  </td>

                                  <td className="tdColor">
                                    <Button style={{width:"85px",marginLeft:"-4px"}}
                                      type="link"
                                      onClick={() =>
                                        this.openLocationModal({
                                          practiceLocation: item.basicDetails.practiceLocation,
                                          website: item.basicDetails.website,
                                        })
                                      }
                                    >
                                     Address ({item.basicDetails.practiceLocation?.length || 0})
                                    </Button>
                                  </td>
                                  


                                  
                                </tr>
                              );
                            })}
                          <tr className="no-bg">
                            <td colspan="15">
                              <Row className="downloadTitle">
                                <Col span="6">
                                  <div>
                                    <span>
                                      <b>
                                        Download All{" "}
                                        {ApiData
                                          ? this.state.TotalCount
                                          : "0"}{" "}
                                        Records
                                      </b>
                                    </span>
                                    <span></span>
                                  </div>
                                </Col>
                                <Col span="6">
                                  <div className="">
                                    <PrimaryButton
                                      className="button-alluser px-3 mx-1"
                                      onClick={this.downloadInPDF}
                                      label={"In PDF"}
                                    />
                                    <PrimaryButton
                                      className="button-alluser px-3 mx-1"
                                      onClick={this.downloadInExcel}
                                      label={"In Excel"}
                                    />
                                    {this.state.DwonloadRosterlodar && ( <span style={{marginLeft:"20px"}}><Spin size="small" /></span> )}
                                  </div>
                                 
                                </Col>
                                
                              </Row>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {this.state.TotalCount > 15 && (
                        <div
                          style={{
                            width: "47vw",
                            display: "inline-block",
                            height: "3em",
                            marginTop: "18px",
                          }}
                        >
                          <Pagination
                            size="small"
                            hideOnSinglePage={true}
                            current={this.state.currentPage}
                            total={this.state.TotalCount}
                            defaultPageSize={this.state.rowsPerPage}
                            showSizeChanger={false}
                            onChange={this.onPageChange}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              ) : null}
              {!this.state.reportLoading &&
              ApiData != null &&
              ApiData.length < 1 ? (
                <div className="blank-screen-placeholder">
                  <div>
                    <div className="centeredText">
                      <img
                        src={blackscreen}
                        style={{ height: "270px", width: "270px" }}
                      />
                    </div>
                    <div className="centeredText">
                      <div className="search-sreen-text">
                        Please Check The Parameter Again
                      </div>
                      <div className="search-sreen-text">Or</div>
                      <div className="search-sreen-text">
                        Search With Different Parameter
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {!this.state.reportLoading && ApiData == null ? (
                <div className="mt-4">
                  <div>
                    <div className="centeredText">
                      <img
                        src={Report_Home}
                        style={{ height: "270px", width: "270px" }}
                      />
                    </div>
                    <div className="centeredText">
                      <div className="search-sreen-text">
                        Enter Details and Search To See The Results
                      </div>
                      <div className="search-sreen-text">Or</div>
                      <div className="search-sreen-text">
                        Search With Different Parameter
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.state.reportLoading && (
                <Row
                  style={{
                    textAlign: "center",
                    marginTop: "30vh",
                  }}
                >
                  <Spin size="large" />
                </Row>
              )}

         
                     

        {/* {(this.state.ApiData.length !== 0 &&
        <Table
        columns={this.columns}
        dataSource={this.getFilteredData()}
        scroll={{ x: 3500 }}   // horizontal scroll
        pagination={{ pageSize: 20 }}
      />
        )} */}


{/* {!this.state.reportLoading && this.state.ApiData !==[]  ? (
                <div className="mt-4">
                  <div>
                    <div className="centeredText">
                      <img
                        src={Report_Home}
                        style={{ height: "270px", width: "270px" }}
                      />
                    </div>
                    <div className="centeredText">
                      <div className="search-sreen-text">
                        Enter Details and Search To See The Results
                      </div>
                      <div className="search-sreen-text">Or</div>
                      <div className="search-sreen-text">
                        Search With Different Parameter
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.state.reportLoading && (
                <Row
                  style={{
                    textAlign: "center",
                    marginTop: "30vh",
                  }}
                >
                  <Spin size="large" />
                </Row>
              )}
 */}



{/* <Modal
  title="Practice Locations"
  open={this.state.locationModalVisible}
  onCancel={this.closeLocationModal}
  footer={null}
  width={1200}
>
  <div style={{ overflowX: "auto" }}>
    <table className="table">
      <thead>
        <tr>
          <th>Status</th>
          <th>Location Name</th>
          <th>Address</th>
          <th>City</th>
          <th>State</th>
          <th>Zip Code</th>
          <th>County</th>
          <th>Phone</th>
          <th>Fax</th>
          <th>Group NPI</th>
          <th>Group Tax ID</th>
          <th>Effective Date</th>
          <th>Termination Date</th>
          <th>Facility ID</th>
          <th>Network Status</th>
        </tr>
      </thead>

      <tbody>
        {this.state.selectedPracticeLocations.map((location, index) => (
          <tr key={location.facilityid || index}>
            <td>{location.practitionerStatus}</td>

            <td>{location.locationName}</td>

            <td>
              {location.lineNumber1}
              {location.lineNumber2
                ? `, ${location.lineNumber2}`
                : ""}
            </td>

            <td>{location.city}</td>

            <td>{location.state}</td>

            <td>{location.zipCode}</td>

            <td>{location.county}</td>

            <td>{location.phone}</td>

            <td>{location.fax}</td>

            <td>{location.groupNPI}</td>

            <td>{location.groupTaxId}</td>

            <td>{location.locationEffDt}</td>

            <td>{location.locationTrmDt}</td>

            <td>{location.facilityid}</td>

            <td>{location.locationNetworkStatus}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</Modal> */}


<Modal
  title="Location Details"
  open={this.state.locationModalVisible}
  onCancel={this.closeLocationModal}
  footer={null}
  width={1500}
>
  <div style={{ overflowX: "auto" }}>
    <table className="table">
      <thead>
        <tr>
          <th>Location Effective Date</th>
          <th>Location End Date</th>
          <th>Location Name</th>
          <th>Address Line 1</th>
          <th>Address Line 2</th>
          <th>City</th>
          <th>State</th>
          <th>Zip Code</th>
          <th>County</th>
          <th>Telephone Number</th>
          <th>Fax Number</th>
          <th>DBA</th>
          <th>Accepting New Patients</th>
          <th>Hours of Operation</th>
          <th>Website</th>
          <th>Location to Show in Directory</th>
        </tr>
      </thead>

      <tbody>
        {this.state.selectedPracticeLocations.map((location, index) => (
          <tr key={location.facilityid || index}>
            
            {/* Location Effective Date */}
            <td>{location.locationEffDt || "-"}</td>

            {/* Location End Date */}
            <td>{location.locationTrmDt || "-"}</td>

            {/* Location Name */}
            <td>{location.locationName || "-"}</td>

            {/* Address Line 1 */}
            <td>{location.lineNumber1 || "-"}</td>

            {/* Address Line 2 */}
            <td>{location.lineNumber2 || "-"}</td>

            {/* City */}
            <td>{location.city || "-"}</td>

            {/* State */}
            <td>{location.state || "-"}</td>

            {/* Zip Code */}
            <td>{location.zipCode || "-"}</td>

            {/* County */}
            <td>{location.county || "-"}</td>

            {/* Telephone Number */}
            <td>{location.phone || "-"}</td>

            {/* Fax Number */}
            <td>{location.fax || "-"}</td>

            {/* DBA */}
            <td>{location.practiceLocationCorporateName || "-"}</td>

            {/* Accepting New Patients */}
            <td>
              {location.hoursOfOperation?.[0]?.acceptingPatients || "-"}
            </td>

            {/* Hours of Operation */}
            <td>
              {location.hoursOfOperation?.[0]?.acceptingPatients || "-"}
            </td>

            {/* Website */}
            <td>{location.website || "-"}</td>

            {/* Location to Show in Directory */}
            <td>
              {location.hoursOfOperation?.[0]?.inDirectory || "-"}
            </td>

          </tr>
        ))}
      </tbody>
    </table>
  </div>
</Modal>

      </div>



    )
  }
}


export default Form.create({ name: "Rosterreport" })(Rosterreport);
